import React, { useState } from "react";
import Topbar from "./topbar";
import Sidebar from "./sidebar";
import { useResponsive } from "../../hooks/mediaQuery";
import { useWaterMonitoringSignalR } from "../../hooks/useWaterMonitoring";
import { useTranslation } from "react-i18next";

const LayoutView: React.FC<{ children: React.ReactNode, pageTitle?: string | undefined }> = ({ children, pageTitle }) => {
    useWaterMonitoringSignalR();
    const { isLg, isXl } = useResponsive();
    const { t } = useTranslation();
    const isMobile = !isLg && !isXl;
    const [openMobileSidebar, setOpenMobileSidebar] = useState<boolean>(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpenMobileSidebar(newOpen);
    };

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar open={openMobileSidebar} setOpen={setOpenMobileSidebar} toggleDrawer={toggleDrawer} isMobile={isMobile} />
            <div className="flex-1 flex flex-col overflow-hidden">
                <Topbar pageTitle={pageTitle && t(pageTitle)} toggleDrawer={toggleDrawer} />
                <main className="flex-1 overflow-y-auto">{children}</main>
            </div>
        </div>
    );
}
export default LayoutView;
